module.exports = __webpack_public_path__ + "img/news-title.392e3e5c.svg";